module.exports = __webpack_public_path__ + "img/MM.32dda71c.png";